<template>
  <b-container class="container-register" fluid>
    <b-row align-h="center" class="mt-5">
      <img src="@/assets/images/logo.png" href="/" alt />
    </b-row>
    <b-row align-h="center" class="mt-4">
      <p class="subtitle-register">
        BIENVENIDO AL PORTAL DE SIMULACROS DE LA UNIVERSIDAD CATÓLICA SAN PABLO
      </p>
    </b-row>
    <b-form @submit.stop.prevent="onSubmit">
      <b-row align-h="center">
        <b-form-input
          placeholder="Nombres"
          ref="nombres"
          id="nombres"
          class="input-register"
          type="text"
          v-model="$v.form.nombres.$model"
          :state="validateState('nombres')"
        />
      </b-row>

      <b-row align-h="center">
        <b-form-input
          placeholder="Apellidos"
          class="input-register"
          ref="apellidos"
          id="apellidos"
          type="text"
          :state="validateState('apellidos')"
          v-model="$v.form.apellidos.$model"
        />
      </b-row>
      <b-row align-h="center">
        <b-form-input
          placeholder="DNI"
          class="input2-register"
          ref="dni"
          id="dni"
          type="number"
          :state="validateState('dni')"
          v-model="$v.form.dni.$model"
        />

        <b-form-input
          placeholder="Celular"
          class="input2-register"
          ref="celular"
          type="number"
          id="celular"
          :state="validateState('celular')"
          v-model="$v.form.celular.$model"
        />
      </b-row>

      <b-row align-h="center">
        <b-form-select
          class="input-register"
          id="colegio"
          placeholder="Colegio"
          ref="colegio"
          :state="validateState('colegio')"
          v-model="$v.form.colegio.$model"
        >
          <option class="placehold-select" :value="null" disabled
            >Colegio</option
          >

          <option
            v-for="(items, key) in colegios"
            :value="items.id"
            :key="key"
            >{{ items.nombre }}</option
          >
        </b-form-select>
      </b-row>
      <b-row align-h="center">
        <b-form-select
          class="input-register"
          id="carrera"
          placeholder="Colegio"
          ref="carrera"
          :state="validateState('carrera')"
          v-model="$v.form.carrera.$model"
        >
          <option :value="null" class="placehold-select" disabled>
            <p style="font-size:12px!important">Carrera</p>
          </option>
          <option
            v-for="(items, key) in carreras"
            :value="items.id"
            :key="key"
            >{{ items.nombre }}</option
          >
        </b-form-select>
      </b-row>
      <b-row align-h="center">
        <b-form-input
          @blur="show2 = false"
          placeholder="Correo"
          id="correo"
          :state="validateState('correo')"
          :onblur="checkEmail(form.correo)"
          class="input-register"
          type="email"
          ref="correo"
          aria-describedby="input-7-live-feedback"
          :readonly="isReadOnly"
          v-model="$v.form.correo.$model"
        />
        <b-form-invalid-feedback id="input-7-live-feedback"
          >Escribir un correo valido</b-form-invalid-feedback
        >
      </b-row>
      <b-row align-h="center">
        <p class="welcome" style="margin-top: 1.5rem;width: 92%;">Para poder proporcionarte el contenido solicitado, debemos almacenar, procesar y dar tratamiento a tus datos personales. Si aceptas que almacenemos tus datos personales para este fin, marca la casilla que está a continuación.</p>
      </b-row>
      <b-row class="ml-4 mt-3" align-h="start">
        <b-form-group id="input-group-4">
          <b-form-checkbox
            @blur="show2 = false"
            class="check-register mr-2"
            ref="terminosdos"
            type="checkbox"
            id="terminosdos"
            label
            :state="validateState('terminosdos')"
            v-model="$v.form.terminosdos.$model"
          >
            <p style="cursor:pointer">
              Sí, acepto permitir que la Universidad Católica San Pablo realice el tratamiento de mis datos de acuerdo al documento contenido en el siguiente <a href="https://admision.ucsp.edu.pe/tratamiento-datos-personales?_ga=2.39776675.1416151126.1688778006-239807366.1688778005" target="blank" >link*</a>
            </p></b-form-checkbox>
        </b-form-group>
      </b-row>
      <b-row class="ml-4 mt-3" align-h="start">
        <b-form-group id="input-group-4">
          <b-form-checkbox
            @blur="show2 = false"
            class="check-register mr-2"
            ref="terminos"
            type="checkbox"
            id="terminos"
            label
            :state="validateState('terminos')"
            v-model="$v.form.terminos.$model"
          >
            <p style="cursor:pointer">
              Sí, acepto los términos y condiciones de la <a href="https://admision.ucsp.edu.pe/terminos-y-condiciones?_ga=2.39776675.1416151126.1688778006-239807366.1688778005" target="blank" >Universidad Católica San Pablo.*</a>
            </p></b-form-checkbox>
        </b-form-group>
      </b-row>
      <b-row class="ml-4" align-h="start">
        <div v-if="this.$v.form.$anyError">
          <p class="error-register">Faltan Campos por completar</p>
        </div>
      </b-row>

      <b-row align-h="center">
        <b-button id="enviar-support" type="submit" class="register-button"
          >SIGUIENTE</b-button
        >
      </b-row>
    </b-form>

    <b-modal
      content-class="modal-finish"
      hide-footer
      ref="modal-simulacro"
      hide-header-close
      centered
      size="md"
    >
      <b-row align-h="center" style="text-align:center" class="examen-finish">
        <img class="error-img" src="@/assets/images/error.svg" alt />
      </b-row>
      <b-row
        align-h="center"
        style="text-align:center; color:#0F376E"
        class="mt-4 mb-3"
      >
        <p>
          Usuario ya se encuentra registrado,por favor verifique sus resultados
        </p>
      </b-row>
      <b-row align-h="center" class="mb-2">
        <button v-if="!loaded" @click="redirect()" class="home-button-login">
          Aceptar
        </button>
      </b-row>
    </b-modal>

    <b-modal
      content-class="modal-finish"
      hide-footer
      ref="modal-error"
      hide-header-close
      centered
      size="md"
    >
      <b-row align-h="center" style="text-align:center" class="examen-finish">
        <img class="error-img" src="@/assets/images/error.svg" alt />
      </b-row>
      <b-row
        align-h="center"
        style="text-align:center; color:#0F376E"
        class="mt-4 mb-3"
      >
        <p>
          {{this.error}}
        </p>
      </b-row>
      <b-row align-h="center" class="mb-2">
        <button v-if="!loaded" @click="redirect()" class="home-button-login">
          Aceptar
        </button>
      </b-row>
    </b-modal>

    <Terminos v-if="activeModal" />
    <semipolar-spinner
      v-if="loaded"
      class="spinner"
      :animation-duration="2000"
      :size="80"
      color="#0F376E"
    />
  </b-container>
</template>
<script>
import Terminos from "@/views/Student/Terminos";
import { mapState } from "vuex";
import { SemipolarSpinner } from "epic-spinners";
import { validationMixin } from "vuelidate";
import {
  email,
  required,
  numeric,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

export default {
  name: "Register",
  mixins: [validationMixin],

  components: {
    SemipolarSpinner,
    Terminos
  },
  data: () => ({
    activeTerminos: false,
    loaded: false,
    isReadOnly: false,
    colegios: {},
    carreras: {},
    emailValid: "",
    show: true,
    target: "nombres",
    show2: false,
    tittle: "Debe completar este campo",
    error:'',
    estudiante:{},
    form: {
      nombres: null,
      apellidos: null,
      dni: null,
      celular: null,
      colegio: null,
      carrera: null,
      correo: null,
      id_seccion: null,
      id_grado: null,
      id_asesor: null,
      terminos: false,
      terminosdos: false,
      codigo: null,
    },
  }),
  validations: {
    form: {
      nombres: {
        required,
      },
      colegio: {
        required,
      },
      terminos: {
        sameAs: sameAs(() => true),
      },
      terminosdos: {
        sameAs: sameAs(() => true),
      },
      correo: {
        email,
        required,
      },
      carrera: {
        required,
      },
      celular: {
        required,
        numeric,
        maxLength: maxLength(9),
        minLength: minLength(9),
      },
      dni: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(9),
      },

      apellidos: {
        required,
      },
    },
  },
  created() {
    let key = JSON.parse(localStorage.getItem("keyAll"));
    this.estudiante = JSON.parse(localStorage.getItem("estudianteKey"));
    this.form.codigo = key.key;
    this.form.id_grado = key.id_grado;
    this.form.id_seccion = key.id_seccion;
    this.form.id_asesor = key.id_usuario;
    this.form.correo= localStorage.getItem("mailEstudiante");

    if(this.estudiante){
        this.form.nombres= this.estudiante.nombre;
        this.form.apellidos= this.estudiante.apellido;
        this.form.dni= this.estudiante.dni;
        this.form.celular= this.estudiante.celular;
        this.form.correo= this.estudiante.correo;
    }
    
    if(this.estudiante || this.form.correo){
      this.isReadOnly=true;
    }

    this.$store.dispatch("getCollegeRegistro", this.form.codigo).then((response) => {
      this.colegios = response.data.colegio;
    });

    this.$store.dispatch("getCareerRegistro", this.form.codigo).then((response) => {
      this.carreras = response.data.carrera;
    });

    console.log(this.estudiante);
  },
  methods: {
    checkEmail(emailAddress) {
      var re = /\S+@\S+\.\S+/;
      this.emailValid = re.test(emailAddress);
    },
    goRouter(url) {
      this.$router.push(url);
    },
    terminos() {
      console.log("termnos");
      this.$store.dispatch("setActiveModal", true);
    },
    redirect() {
      this.$router.push("/");
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      this.loaded = true;
      this.$store
        .dispatch("postRegisterStudent", this.form)
        .then((response) => {
          if (response.data.existe == 0) {
            if(response.data.error){
              this.error=response.data.error;
              this.loaded = false;
              this.$refs["modal-error"].show();
            }else{
              this.$store.commit("setname", this.form);
              this.$store.dispatch("setToken", response.data.token);
              this.$store.dispatch("setStudent", response.data);
              this.$store.dispatch("setModulo", "INSTRUCCIONES");
              localStorage.setItem("menu", 1);
              localStorage.setItem("idkey", response.data.estudiante.key_simulacro);
              this.loaded = false;
              this.$router.push("simulacros");
            }
          }
          if (response.data.existe > 0) {
            this.loaded = false;
            this.$refs["modal-simulacro"].show();
          }

        });
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
  computed: {
    ...mapState(["activeModal"]),
    isDisabled() {
      if (
        this.form.terminos === true &&
        this.emailValid === true &&
        this.form.codigo &&
        this.form.nombres &&
        this.form.dni &&
        this.form.celular &&
        this.form.carrera
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped></style>
